import React, { useMemo } from "react"
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer"
import { calTax, enum_GstType, getAmountToWords, getBillType, getDateFn, getGSTPer, getGstTax, getMemoParticular, getPktType, getTradeOf } from "./ReportUtility.js"
import { calculateTotal } from "../../Utility/utility.js"

const RptInvoice = ({ rptdata, moddata, fsize }) => {

    let visibleCol = []
    //console.log(rptdata,moddata)
    if (moddata && Object.keys(moddata).length > 0) {
        visibleCol = moddata.pageData.filter((ele) => ele.Visible == 'true').map((itm) => itm.Parameter)
    }
    let totalQty = 0
    let totalAmt = 0
    let totalDiscAmt = 0
    let totalCGst = 0
    let totalSGst = 0
    let data = []
    if (rptdata && rptdata.length > 0)
        data = rptdata.filter((val, ind) => ind === 0) //
    const isMoreThanFive = rptdata.length > 5;

    const border_color = "#2f2e2e"
    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#FFFFFF',
        },
        section: {
            fontFamily: 'Helvetica',
            margin: 20,
            padding: 0,
            flexGrow: 1,
            fontSize: "8px",
            borderColor: "#475569",
            borderWidth: "0px",
            //borderTopWidth: "0px"
        },
        table: {
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderTopWidth: 0,
            borderRightWidth: 0,
            borderBottomWidth: 0
        },
        topBox: {
            width: "50%",
            borderBottomWidth: 1,
            padding: "2px 3px",
            fontSize: "9px"
        },
        tableRow: {
            margin: 'auto',
            flexDirection: 'row',
            width: "100%"
        },
        tableColHeader: {
            borderRightWidth: 1,
            textAlign: "center",
            padding: "5px 0px",
            fontSize: "9px"
        },
        tableCol: {
            borderStyle: 'solid',
            borderTopWidth: 0,
        },
        tableCell: {
            padding: "1.5px",
        },
        colMid: {
            padding: "0px 3px 0px 3px"
        },
        srno: {
            width: "10%"
        },
        desc: {
            width: "70%"
        },
        hsn: {
            width: "40%"
        },
        gst: {
            width: "20%"
        },
        qty: {
            width: "20%"
        },
        rate: {
            width: "30%"
        },
        amt: {
            width: "30%"
        },
        fontBold: {
            fontFamily: 'Helvetica-Bold',
        },
        tableTopBorder: {
            borderTop: 1,
            borderColor: border_color,
        },
        tableBottomBorder: {
            borderBottom: 1,
            borderColor: border_color,
        },
        Heading: {
            fontSize: "13px",
            textTransform: "uppercase",
            textAlign: "center",
            fontFamily: 'Helvetica-Bold',
        },
        colWidth: {
            width: "80%",
            textAlign: "left",
        },
        colWidth_label: {
            width: "20%",
            fontSize: "9px"
        },
        footerText: {
            fontSize: "8px",
            fontWeight: 600,
            textTransform: "uppercase",
            fontFamily: 'Helvetica-Bold'
        },
        tblBorderLeft: {
            borderLeftWidth: 1
        },
        tblBorderRight: {
            borderRightWidth: 1
        },
        colBorder: {
            textAlign: "center",
            padding: "3px"
        },
        tblBox: {
            borderBottomWidth: "1px",
            width: "50%",
            padding: "3px 5px",

        },
        tblBoxlabel: {
            paddingBottom: "5px",
            fontSize: "9px"

        },

        totalCol1: {
            width: "45%",
            padding: "3px 0px"

        },
        totalCol2: {
            width: "55%",
            textAlign: "right",
            padding: "3px 0px"
        },
        scaledContent: {
            transform: `scale(${fsize})`,
            transformOrigin: 'top left',
        },
        continueTextBottom: {
            //position: "absolute",
            width: "100%",
            padding: "5px",
            fontSize: 8,
            fontStyle: "italic",
            textAlign: "right",
        }

    })
    const InvoiceCompInfoHead = (item) => {
        return (
            <View style={[styles.tableRow,]}>
                <View style={[styles.tableCol, styles.topBox, styles.tblBorderRight,]}>
                    {/* Comp iNFo */}
                    <View style={{ padding: "3px" }}>
                        <View style={[styles.fontBold, { fontSize: "10px", marginBottom: "2px" }]}><Text  >{item?.CompName}</Text></View>
                        <View><Text>{item?.Comp_Add1 +
                            " " +
                            item?.Comp_Add2 +
                            " " +
                            item?.Comp_Add3 +
                            " " +
                            item?.Comp_Add4 +
                            " " +
                            item?.Comp_City +
                            " " +
                            item?.Comp_State}</Text></View>
                    </View>
                    <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>PAN NO</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth, styles.fontBold]}>
                                <Text style={styles.tableCell}>{item.Comp_PANNo}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>GST NO</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth, styles.fontBold]}>
                                <Text style={styles.tableCell}>{item.Comp_GSTNo}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>State</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.Comp_State}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>Contact</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.Comp_ContectNo1}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>E-Mail</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.Comp_EmailId}</Text>
                            </View>

                        </View>
                    </View>
                </View>
                <View style={[styles.tableCol, styles.topBox, { padding: "0px" }]}>
                    <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.tblBox, styles.tblBorderRight]}>
                                <Text style={[styles.tblBoxlabel]} >Invoice No.</Text>
                                <Text style={[styles.fontBold]} >{item?.Bill_No}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.tblBox]}>
                                <Text style={[styles.tblBoxlabel]}>Invoice Date.</Text>
                                <Text style={[styles.fontBold]}>{getDateFn(item?.Bill_Date)}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.tblBox, styles.tblBorderRight]}>
                                <Text style={[styles.tblBoxlabel]} >Mode/Terms :of Payment</Text>
                                <Text style={[styles.fontBold]} >{item?.DueDays > 0 ? item?.DueDays : "C.O.D"}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.tblBox]}>
                                <Text style={[styles.tblBoxlabel]}>Due Date.</Text>
                                <Text style={[styles.fontBold]}>{getDateFn(item?.DueDate)}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.tblBox, styles.tblBorderRight]}>
                                <Text style={[styles.tblBoxlabel]} >Place of Supply</Text>
                                <Text style={[styles.fontBold]} >{item?.Comp_City + " " + item?.Comp_State}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.tblBox]}>
                                <Text style={[styles.tblBoxlabel]}>Date of Supply</Text>
                                <Text style={[styles.fontBold]}>{getDateFn(item?.Bill_Date)}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, styles.tblBox, styles.tblBorderRight, { borderBottomWidth: "0" }]}>
                                <Text style={[styles.tblBoxlabel]} >Transport Mode</Text>
                                <Text style={[styles.fontBold]} ></Text>
                            </View>
                            <View style={[styles.tableCol, styles.tblBox, { borderBottomWidth: "0" }]}>
                                <Text style={[styles.tblBoxlabel,]}>Destination</Text>
                                <Text style={[styles.fontBold]}>{item?.PAdd_5}</Text>
                            </View>
                        </View>
                    </View>

                </View>
            </View>
        )
    }
    const InvoicePartyInfoHead = (item) => {
        return (
            <View style={[styles.tableRow,]}>
                {/* party info */}
                <View style={[styles.tableCol, styles.topBox, styles.tblBorderRight]}>
                    <View style={{ padding: "3px" }}>
                        <View style={[styles.fontBold, { fontSize: "8px", paddingBottom: "3px", textDecoration: "underline" }]}>
                            <Text>Buyer (Bill to)</Text></View>
                        <View style={[styles.fontBold, { fontSize: "9px", marginBottom: "5px" }]}>
                            <Text>{item?.PartyName}</Text></View>
                        <View><Text>{item?.PAdd_1 +
                            " " +
                            item?.PAdd_2 +
                            " " +
                            item?.PAdd_3 +
                            " " +
                            item?.PAdd_4 +
                            " " +
                            item?.PAdd_5 +
                            " " +
                            item?.PState}</Text></View>
                    </View>
                    <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>PAN NO</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth, styles.fontBold]}>
                                <Text style={styles.tableCell}>{item.Party_PAN}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>GST NO</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth, styles.fontBold]}>
                                <Text style={styles.tableCell}>{item.Party_GSTNo}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>State</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.PState}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>Contact</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.Party_ContectNo1}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>E-Mail</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.Party_EMailId}</Text>
                            </View>

                        </View>
                    </View>
                </View>
                {/* ship info */}
                <View style={[styles.tableCol, styles.topBox]}>
                    <View style={{ padding: "3px" }}>
                        <View style={[styles.fontBold, { fontSize: "8px", paddingBottom: "3px", textDecoration: "underline" }]}>
                            <Text>Consignee (Ship to)</Text></View>
                        <View style={[styles.fontBold, { fontSize: "9px", marginBottom: "5px" }]}>
                            <Text>{item?.DeliveryName}</Text></View>
                        <View><Text>{
                            item?.DAdd_1 +
                            " " +
                            item?.DAdd_2 +
                            " " +
                            item?.DAdd_3 +
                            " " +
                            item?.DAdd_4 +
                            " " +
                            item?.DAdd_5 +
                            " " +
                            item?.DState}</Text></View>
                    </View>
                    <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>PAN NO</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth, styles.fontBold]}>
                                <Text style={styles.tableCell}>{item.D_PAN}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>GST NO</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth, styles.fontBold]}>
                                <Text style={styles.tableCell}>{item.D_GSTNo}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>State</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.DState}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>Contact</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.D_ContectNo1}</Text>
                            </View>

                        </View>
                        <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                                <Text style={styles.tableCell}>E-Mail</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                                <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                                <Text style={styles.tableCell}>{item?.D_EMailId}</Text>
                            </View>

                        </View>
                    </View>
                </View>
            </View>
        )
    }

    const InvoiceFoot = (item) => {
        return (
            <View>
                <View style={[{ fontSize: "7px", padding: "5px", lineHeight: 1.5 }]}>
                    <View style={[styles.table, styles.fontBold, { marginBottom: "3px" }]}>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableColItem, { width: "50%" }]}>
                                <Text style={[styles.tableCellItem]}>
                                    <Text style={[{ fontSize: "7px", textTransform: "uppercase" }]}>{"Subject To " + item?.Comp_City + " Jurisdiction"}</Text>
                                </Text>
                            </View>
                            <View style={[styles.tableColItem, { width: "50%" }]}>
                                <Text style={[styles.tableCellItem]}>
                                    <Text style={[{ fontSize: "7px" }]}>:Declaration: </Text>
                                </Text>
                            </View>
                        </View>
                    </View>
                    <Text>The diamonds herein invoiced have been purchased from legitimate sources not involved in funding conflict, in compliance with United Nations Resolutions and corresponding
                        national laws. The seller hereby guarantees that these diamonds are conflict free and confirms adherence to the World Diamond Council System of Warranties Guidelines. The
                        Acceptance of goods herein invoiced will be as per WFDB guidelines .To the best of our knowledge and/or written assurances from our Suppliers, We state that "Diamonds
                        herein invoiced have not been obtained in violation of applicable National Laws and /or sections by the U.S. Department of Treasury's office of Foreign Assets Control (OFAC)
                        and have not originated from the Mbada and Marrange resources of Zimbabwe ."The Diamonds herein invoiced are exclusively of natural origin and untreated based on
                        personal knowledge and/or written guarantees provided by the supplier of these Diamonds .I/we hereby certify that my/our registration certificate under The Central / State
                        Goods and Services Tax Act, 2017 in force on the date on which sale of goods specified in this tax invoice is made by me /us and that the transaction of sale covered by this tax
                        invoiced has been effected by me/us and it shall be accounted for in the turnover of sale while filing of return and the due tax, if any, payable on the supply has been paid or
                        shall be paid.We hereby declare that the Diamond involved herein guaranteed as natural and there are no Synthetic /CVD/HPHT or any other artificial process involved at any
                        stage of manufacturing and processing of these diamonds .The Diamond supplied by us are not artificiality enhanced or laser treated .Notification : E way bill exemption under
                        notification no 27/2017 - central tax dated 31/08/2017 for goods mentioned in annexure under serial no. 150 &151 under rule no.138(14) for goods specified under chapter
                        71.TCS applicable on making sales payment w.e.f 01st Oct 2020. We request if your purchase payment above Rs .50 Lakhs make additional payment of TCS on excess
                        amount rate of 0.10% before month of end. We declare that the diamonds sold have not been cut from rough diamonds originating from Russia

                    </Text>
                </View>

                <View style={[styles.table, styles.fontBold, styles.tableTopBorder, styles.tableBottomBorder]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableColItem, styles.tblBorderRight, { width: "70%" }]}>
                            <View style={[styles.table,]}>
                                <View style={[styles.tableRow, { padding: "3px", lineHeight: "1" }]}>
                                    <View style={[styles.tableColItem, { fontSize: "8px", }]}>
                                        <Text style={[styles.tableCellItem, { textDecoration: "underline" }]}>
                                            PAYMENT INSTRUCTION:
                                        </Text>
                                        <View style={[styles.table,]}>
                                            <View style={[styles.tableRow]}>
                                                <View style={[styles.tableColItem, { width: "20%" }]}>
                                                    <Text style={[styles.tableCellItem]}>
                                                        Bank Name
                                                    </Text>
                                                </View>
                                                <View style={[styles.tableColItem,]}>
                                                    <Text style={[styles.tableCellItem]}>
                                                        {" : " + item?.BankName}
                                                    </Text>
                                                </View>
                                            </View>
                                            <View style={[styles.tableRow]}>
                                                <View style={[styles.tableColItem, { width: "20%" }]}>
                                                    <Text style={[styles.tableCellItem]}>
                                                        A/C No
                                                    </Text>
                                                </View>
                                                <View style={[styles.tableColItem,]}>
                                                    <Text style={[styles.tableCellItem,]}>

                                                    </Text>
                                                    <View style={[{ flexDirection: "row" }]}>
                                                        <Text style={[{ width: "60%" }]}>     {" : " + item?.BankAccNo}</Text>
                                                        <Text style={[]}> IFSC Code  : {item?.BankIFSCCode}</Text>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.tableRow]}>
                                                <View style={[styles.tableColItem, { width: "20%" }]}>
                                                    <Text style={[styles.tableCellItem]}>
                                                        Address
                                                    </Text>
                                                </View>
                                                <View style={[styles.tableColItem,]}>
                                                    <Text style={[styles.tableCellItem]}>
                                                        {" : " + item?.BankAddress}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>

                                    </View>
                                </View>
                                <View style={[styles.tableRow, styles.tableTopBorder, { fontSize: "7px" }]}>
                                    <View style={[styles.tableColItem, { width: "70%", padding: "3px" }]}>
                                        <Text style={[styles.tableCellItem, { marginBottom: "3px" }]}>
                                            e-invoice Detail:
                                        </Text>
                                        <View><Text style={[{ paddingBottom: "3px" }]}>IRN : {item?.EINV_IRN}</Text></View>
                                        <View style={[{ flexDirection: "row" }]}><Text style={[{ width: "50%" }]}>Ack No.: {item?.EINV_ACKNO}</Text> <Text>Ack Date.: {item?.EINV_ACKDATE}</Text></View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.tableColItem, { width: "30%" }]}>
                            <Text style={[styles.tableCellItem]}>

                            </Text>
                        </View>
                    </View>
                </View>


                <View style={[styles.table,]}>
                    <View style={[styles.tableRow,]}>
                        <View style={[styles.tableColItem, styles.tblBorderRight, { width: "50%" }]}>
                            <Text style={[styles.tableCellItem, { padding: "5px", fontSize: "8px" }]}>
                                <Text style={[{ lineHeight: 1 }]}>
                                    Customer's Seal and Signature
                                </Text>
                            </Text>
                            <View style={[{ padding: "5px" }, styles.fontBold]} ><Text >Receiver's Signatory________________</Text></View>
                        </View>
                        <View style={[styles.tableColItem, styles.fontBold, { width: "50%", textAlign: "right" }]}>
                            <Text style={[styles.tableCellItem, { padding: "5px" }]}>
                                <Text style={[{ lineHeight: 1 }]}>For : {item?.CompName} </Text>
                            </Text>
                            <View style={[{ padding: "5px" }]}><Text>Authorised Signatory</Text></View>
                        </View>
                    </View>
                </View>
            </View>
        )
    }


    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={[styles.scaledContent]}>
                    {
                        data && data.map((item, index) => {
                            return (
                                <View style={styles.section}>
                                    {/* HEader */}
                                    <Text style={[styles.fontBold, { textAlign: "center" }]}>T A X   I N V O I C E</Text>
                                    <View style={[{ borderWidth: "1px" }]}>
                                        <View style={[styles.table,]}>
                                            {InvoiceCompInfoHead(item)}
                                            {InvoicePartyInfoHead(item)}
                                        </View>

                                        {/* Detail info */}
                                        <View style={[styles.table]}>
                                            <View style={[styles.tableRow, styles.font_bold, { borderBottom: "1px" }]}>
                                                <View style={[styles.tableColItem, styles.srno, styles.tableColHeader]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>Sr No.</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.desc, styles.tableColHeader]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>Description Of Goods</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.hsn, styles.tableColHeader]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>HSN No</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.gst, styles.tableColHeader]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>GST</Text>
                                                    <Text style={[styles.fontBold]}> Rate % </Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.qty, styles.tableColHeader]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>Quantity</Text>
                                                    <Text style={[{ marginTop: "5px" }]}>CRT</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.rate, styles.tableColHeader,]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>Rate</Text>
                                                    <Text style={[{ marginTop: "5px" }]}> (Rs.)</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.amt, styles.tableColHeader, { borderRightWidth: "0px" }]}>
                                                    <Text style={[styles.tableCellItem, styles.fontBold]}>AMOUNT</Text>
                                                    <Text style={[{ marginTop: "5px" }]}> (Rs.)</Text>
                                                </View>
                                            </View>
                                        </View>

                                        <div style={{ minHeight: "75px" }}>

                                            <View style={[styles.table]}>
                                                {rptdata.map((itemlist, inx) => {
                                                    totalQty += parseFloat(itemlist?.BD_Weight ?? 0)
                                                    totalAmt += parseFloat(itemlist?.BD_Amount ?? 0)-parseFloat(itemlist?.BD_DiscAmt ?? 0)
                                                    totalDiscAmt += parseFloat(itemlist?.BD_DiscAmt ?? 0)
                                                    totalCGst += parseFloat(itemlist?.BD_StAmt ?? 0)
                                                    totalSGst += parseFloat(itemlist?.BD_AstAmt ?? 0)
                                                    return (
                                                        <View style={[styles.tableRow,]}>
                                                            <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data]}>{(inx += 1)}</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data, { fontSize: "7px" }]}>{itemlist?.Item_Desc}
                                                                    {getMemoParticular(visibleCol, itemlist)}
                                                                </Text>
                                                                <Text>
                                                                    {itemlist?.Item_Det}
                                                                </Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.hsn, styles.colBorder]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data, styles.fontBold]}>{itemlist?.HsnNo}</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.gst, styles.colBorder,]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.BD_StPer + itemlist?.BD_AstPer}</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.qty, styles.colBorder]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.BD_Weight}</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.Rate}</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.amt, styles.colBorder,]}>
                                                                <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: "5px" }]}>{itemlist?.BD_Amount.toFixed(2)}</Text>
                                                            </View>
                                                        </View>

                                                    )
                                                })}
                                            </View>

                                        </div>

                                        {/*  Detail footer */}
                                        <View style={[styles.table, styles.tbl_color, { fontSize: "8px" }]}>
                                            <View style={[styles.tableRow, styles.fontBold]}>
                                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.hsn, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.gst, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.qty, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.rate, styles.colBorder, { fontSize: "8px" }]}>
                                                    <Text style={[styles.tableCellItem]}>Disc Amount</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.amt, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>{item?.DiscAmt.toFixed(2)}</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.tableRow, styles.fontBold]}>
                                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.desc, styles.colBorder, { fontSize: "8px" }]}>
                                                    <Text style={[styles.tableCellItem]}>Total</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.hsn, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.gst, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.qty, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}>{totalQty.toFixed(2)}</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.rate, styles.colBorder, { fontSize: "8px" }]}>
                                                    <Text style={[styles.tableCellItem]}>Taxable value</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.amt, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>{totalAmt.toFixed(2)}</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.tableRow, styles.tableTopBorder, styles.fontBold]}>
                                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.hsn, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.gst, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.qty, styles.colBorder, { fontSize: "8px" }]}>
                                                    <Text style={[styles.tableCellItem,]}>CGST</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right" }]}> {getGSTPer(item?.Trade_Type, enum_GstType.CGST)
                                                        ? item.BD_StPer && item.BD_StPer != null ? item.BD_StPer + " %" : "0 %"
                                                        : "0 %"}</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.amt, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>
                                                        {getGstTax(item?.Trade_Type, enum_GstType.CGST)
                                                            ? totalCGst.toFixed(2) : "0.00"}
                                                        {/* //item?.STAmt */}
                                                    </Text>
                                                </View>

                                            </View>
                                            <View style={[styles.tableRow, styles.fontBold]}>
                                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.hsn, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.gst, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.qty, styles.colBorder, { fontSize: "8px" }]}>
                                                    <Text style={[styles.tableCellItem,]}>SGST</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right" }]}> {getGSTPer(item?.Trade_Type, enum_GstType.SGST)
                                                        ? item.BD_AstPer && item.BD_AstPer != null ? item.BD_AstPer + " %" : "0 %"
                                                        : "0 %"}</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.amt, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>
                                                        {getGstTax(item?.Trade_Type, enum_GstType.SGST)
                                                            ? totalSGst.toFixed(2) : "0.00"}  { }</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.tableRow, styles.fontBold]}>
                                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.hsn, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.gst, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem,]}></Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.qty, styles.colBorder, { fontSize: "8px" }]}>
                                                    <Text style={[styles.tableCellItem,]}>IGST</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right" }]}> {getGSTPer(item?.Trade_Type, enum_GstType.IGST)
                                                        ? item.BD_StPer && item.BD_StPer != null ? item.BD_StPer + " %" : "0 %"
                                                        : "0 %"}</Text>
                                                </View>
                                                <View style={[styles.tableColItem, styles.amt, styles.colBorder,]}>
                                                    <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>
                                                        {getGstTax(item?.Trade_Type, enum_GstType.IGST)
                                                            ? totalCGst.toFixed(2) : "0.00"}
                                                        {/* //item?.STAmt */}
                                                    </Text>
                                                </View>
                                            </View>


                                        </View>
                                        <View style={[styles.table, styles.fontBold, { width: "100%" }, styles.tableTopBorder, styles.tableBottomBorder]}>
                                            <View style={[styles.tableRow,]}>
                                                <View style={[styles.tableColItem, styles.tblBorderRight, { width: "60%", fontSize: "7px" }]}>
                                                    <Text style={[styles.tableCellItem, { padding: "5px" }]} >
                                                        <Text style={[{ lineHeight: 1 }]}>    <Text style={[{ addingLeft: "10px" }]} >( In Word ) </Text>
                                                            {"          " + getAmountToWords(item?.NetAmt)}</Text>
                                                    </Text>
                                                    <View ><Text style={[{ padding: "3px" }]}>The above goods are sent on out-right sale basis. Part payment allowed on or before due date. </Text></View>
                                                </View>

                                                <View style={[styles.tableColItem, { width: "40%", padding: "5px" },]}>
                                                    <View style={[styles.table, { width: "100%", fontSize: "8px" }]}>
                                                        <View style={[styles.tableRow, { lineHeight: 1 }]}>
                                                            <View style={[styles.tableColItem, styles.totalCol1]}>
                                                                <Text style={[styles.tableCellItem]}>Total Tax Amount</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.totalCol2,]}>
                                                                <Text style={[styles.tableCellItem]}>
                                                                    {(totalCGst + totalSGst).toFixed(2)}
                                                                </Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.tableRow,]}>
                                                            <View style={[styles.tableColItem, styles.totalCol1,]}>
                                                                <Text style={[styles.tableCellItem]}>Round Off</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.totalCol2,]}>
                                                                <Text style={[styles.tableCellItem]}>{(((totalAmt) + item?.STAmt + item?.AstAmt) - item?.NetAmt).toFixed(2)} </Text>
                                                            </View>
                                                            {/* //totalAmt - item?.DiscAmt ?? 0 */}
                                                        </View>
                                                        <View style={[styles.tableRow,]}>
                                                            <View style={[styles.tableColItem, styles.totalCol1,]}>
                                                                <Text style={[styles.tableCellItem]}>Total Invoice Amount</Text>
                                                            </View>
                                                            <View style={[styles.tableColItem, styles.totalCol2,]}>
                                                                <Text style={[styles.tableCellItem]}>{item.NetAmt.toFixed(2)}</Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                        {!isMoreThanFive ?
                                            InvoiceFoot(item) : ""}

                                    </View>
                                    <View style={styles.continueTextBottom}>
                                        <Text>{isMoreThanFive ? " To be Continue..." : ""}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }

                </View>
            </Page>

            {isMoreThanFive && (
                <Page size="A4" style={styles.page}>
                    <View style={[styles.scaledContent]}>
                        <View style={styles.section}>
                            {/* HEader */}
                            <Text style={[styles.fontBold, { textAlign: "center" }]}>T A X   I N V O I C E</Text>
                            <View style={[{ borderWidth: "1px" }]}>
                                <View style={[styles.table,]}>
                                    {InvoiceCompInfoHead(data?.[0])}

                                </View>
                                {InvoiceFoot(data?.[0])}
                            </View>
                        </View>
                    </View>
                </Page>
            )}
        </Document>
    )
}
export default RptInvoice